import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function FlexibleBookingsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <path d="M34.43 6.69H29.8V5.53a.61.61 0 00-1.21 0v1.16h-4.85V5.53a.61.61 0 00-1.21 0v1.16h-4.85V5.53a.61.61 0 00-1.21 0v1.16h-4.84V5.53a.61.61 0 00-1.21 0v1.16H5.78a1.19 1.19 0 00-1.21 1.17v25a1.19 1.19 0 001.21 1.17h28.65a1.19 1.19 0 001.21-1.17v-25a1.19 1.19 0 00-1.21-1.17zM5.78 7.86h4.63V9a.61.61 0 001.21 0V7.86h4.84V9a.61.61 0 001.21 0V7.86h4.84V9a.61.61 0 001.21 0V7.86h4.85V9a.61.61 0 001.23 0V7.86h4.63v4.34H5.78V7.87zm28.64 25H5.78V13.37h28.65V32.9z"/>
      <path d="M23.13 17a4.27 4.27 0 00-3 1.25 4.26 4.26 0 00-3-1.25 4.2 4.2 0 00-4.24 4.16c0 4.75 7.27 8.91 7.27 8.91s7.27-4.16 7.27-8.91a4.2 4.2 0 00-4.3-4.16zM23 26.48a23 23 0 01-2.85 2.17 23.05 23.05 0 01-2.85-2.17c-1.51-1.33-3.3-3.32-3.3-5.34a3 3 0 013-3 3 3 0 012.16.89l.87.87.87-.87a3 3 0 012.16-.89 3 3 0 013 3c0 2-1.75 4-3.21 5.33z"/>
    </SvgIcon>
  )
}
export default FlexibleBookingsIcon
